




































import { Component, Vue, Watch, PropSync, Prop } from "vue-property-decorator";
// import { decorationData, questionData, testData, QuestionDataType } from "../../config/questionnaire";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import auditSetting_select from "./auditSetting_select.vue";
import auditSetting_text from "./auditSetting_text.vue";
import auditSetting_number from "./auditSetting_number.vue";
import auditSetting_date from "./auditSetting_date.vue";
@Component({
  name: "auditSetting",
  components: { auditSetting_select, auditSetting_text, auditSetting_number, auditSetting_date },
  filters: {},
})
export default class auditSetting extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled?: any;

  ifItems_date: any = [];
  ifItems_number: any = [];
  ifItems_text: any = [];
  ifItems_select: any = [];
  noneDecoItems: any = [];
  private localSubmit = {};
  private postForm: any = {
    itemVerificationList: [],
  };

  // private rules = {
  //   title: [{ required: true, type: "string", message: "请填写标题", trigger: "blur" }],
  // };

  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get dataList() {
    return QuestionnaireEditModule.dataList;
  }
  get verificationConfig() {
    return QuestionnaireEditModule.verificationConfig;
  }
  init() {
    this.initIfItems();
    this.initPostForm();
  }
  private uniqueArr = [25, 26, 27, 28, 29];

  deleteLogic(index: number) {
    this.postForm.itemVerificationList.splice(index, 1);
  }
  addItem(type: string) {
    //
    console.log("addItem", type);
    if (type == "VERIFICATION_OPTION") {
      this.postForm.itemVerificationList.push({
        type: "VERIFICATION_OPTION",
        ///
        ifItem: "",
        operate: "",
        itemOptions: [],
        ///////////
        ifItemOptions: [],
        ifItemIndex: "",
        ifItemIsRadio: false,
        ////
        compareItem: "",
        compareOperate: "",
        compareOptions: [],
        ///
        compareItemOptions: [],
        compareItemIndex: "",
        compareItemIsRadio: false,

        /////
        verificationResult: "FAIL",
      });
    }
    if (type == "VERIFICATION_WORD") {
      this.postForm.itemVerificationList.push({
        type: "VERIFICATION_WORD",
        ///
        ifItem: "",
        operate: "",
        ifItemContent: "",

        ///////////
        ifItemIndex: "",
        ////
        compareItem: "",
        compareOperate: "",
        ///
        compareItemIndex: "",
        compareItemContent: "",
        /////
        verificationResult: "FAIL",
      });
    }
    if (type == "VERIFICATION_NUMBER") {
      this.postForm.itemVerificationList.push({
        type: "VERIFICATION_NUMBER",
        ///
        ifItem: "",
        operate: "",

        ///////////
        ifItemIndex: "",
        ////
        compareItem: "",
        ///
        compareItemIndex: "",
        /////
        verificationResult: "FAIL",
      });
    }
    if (type == "VERIFICATION_DATE") {
      this.postForm.itemVerificationList.push({
        type: "VERIFICATION_DATE",
        ///
        ifItem: "",
        operate: "",

        ///////////
        ifItemIndex: "",
        ////
        compareTarget: "",
        compareItem: "",
        compareAction: "SUBMIT_TIME",
        compareItemContent: "",
        ///
        compareItemIndex: "",
        /////
        verificationResult: "FAIL",
      });
    }
  }

  initIfItems() {
    let dataList = JSON.parse(JSON.stringify(this.dataList));

    this.noneDecoItems = dataList.filter((item: any) => {
      return ![15, 16, 5, 8, 24].includes(item.componentName);
    });
    this.noneDecoItems.forEach((item: any, index: string) => {
      item.index = index + 1;
    });
    this.ifItems_date = dataList.filter((item: any) => {
      return [13, 28].includes(item.componentName);
    });
    this.ifItems_number = dataList.filter((item: any) => {
      return [11, 12].includes(item.componentName);
    });
    this.ifItems_text = dataList.filter((item: any) => {
      // return [3, 11].includes(item.componentName);
      if ([3, 11].includes(item.componentName)) {
        return true;
      } else if (item.componentName == 29 && item.data.optionContentType == "FILLIN") {
        return true;
      } else {
        return false;
      }
    });
    this.ifItems_select = dataList.filter((item: any) => {
      if ([1, 2, 9, 10, 27].includes(item.componentName)) {
        return true;
      } else if (item.componentName == 29 && item.data.optionContentType == "TEXT") {
        return true;
      } else {
        return false;
      }
    });
    // this.ifItems.forEach((item: any) => {
    //   item.index =
    //     this.noneDecoItems.findIndex((item: any) => {
    //       return item.data.id == item.data.id;
    //     }) + 1;
    // });
  }
  getFormInstance() {
    return this.$refs.postForm as any;
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
  findIndex_nodecoItems(id: string) {
    if (id) {
      let oifItemIndex: any = this.noneDecoItems.findIndex((item: any) => {
        return item.data.id == id;
      });
      return oifItemIndex;
    } else {
      return -1;
    }
  }

  initPostForm() {
    let postForm = JSON.parse(JSON.stringify(this.verificationConfig));
    postForm.itemVerificationList.forEach((logic: any) => {
      if (logic.type == "VERIFICATION_OPTION") {
        const itemIndex = this.findIndex_nodecoItems(logic.ifItem);
        logic.ifItemIndex = itemIndex >= 0 ? itemIndex : 0;
        logic.ifItemOptions = itemIndex >= 0 ? (this.noneDecoItems[itemIndex] as any).data.optionsList : [];

        const compareItemIndex = this.findIndex_nodecoItems(logic.compareItem);
        logic.compareItemIndex = compareItemIndex >= 0 ? compareItemIndex : 0;
        logic.compareItemOptions = compareItemIndex >= 0 ? (this.noneDecoItems[compareItemIndex] as any).data.optionsList : [];
      }
      if (logic.type == "VERIFICATION_WORD" || logic.type == "VERIFICATION_NUMBER" || logic.type == "VERIFICATION_DATE") {
        const itemIndex = this.findIndex_nodecoItems(logic.ifItem);
        logic.ifItemIndex = itemIndex >= 0 ? itemIndex : 0;

        const compareItemIndex = this.findIndex_nodecoItems(logic.compareItem);
        logic.compareItemIndex = compareItemIndex >= 0 ? compareItemIndex : 0;
      }
    });

    this.postForm = postForm;
  }

  // $ handleModules

  getModulesConfigInstance() {
    return this.$refs.modulesConfig as any;
  }

  getSubmitConfigInstance() {
    return this.$refs.submitConfig as any;
  }

  async validateForSave() {
    // 保存总配置时,用来最终效验有没有失效项目
    // this.clearValidate();
    console.log("auditlogic updateData", this.postForm);
    // console.log("logicSetvalidateForSave");
    await this.initIfItems();
    await this.initPostForm();
    return await this.validate();
  }
  async updateData() {
    console.log("auditlogic updateData", this.postForm);
    QuestionnaireEditModule.SET_verificationConfig(this.postForm);
  }
  async validate() {
    if (this.postForm.itemVerificationList.length == 0) {
      QuestionnaireEditModule.SET_verificationConfig(this.postForm);
      return true;
    }
    if (!this.getFormInstance()) {
      // this.visible = true;
      return false;
    }
    let result = await this.getFormInstance()
      .validate()
      .catch(() => {
        return false;
      });
    console.log("itemVerificationListValidate", result);
    if (result) {
      QuestionnaireEditModule.SET_verificationConfig(this.postForm);
    }
    return result;
  }
  closeDialog() {
    this.initPostForm();
  }
  async handleCommit() {
    let vali = await this.validate();
    console.log("validate", vali);
  }
}
